<template>
  <div class="main-infoVersions">
    <h1>Информация о версиях</h1>
    <div class="list-versions">
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 13.10.2026 (v0.300)</b>
        </div>
        <div class="list-versions-item-info">
          - Больше обновление. Добавлена возможность начислять детям достижения.
          Этот инструмент по большей части написан с помощью ИИ, нужно провести
          тестирование на больших данных. <br />
          - В настройках добавлен "Свод по ученикам", это свод со всей
          информации, которая имеется в АСТ в обобщенном режиме.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 09.10.2026 (v0.299.4)</b>
        </div>
        <div class="list-versions-item-info">
          - небольшое исправление по отправке заявок меню: теперь кнопка будет
          неактивна после нажатия, пока сервер не отправит данные. Это должно
          исправить ситуацию с появлением дублей классов (некоторые нажимали
          кнопку несколько раз, а запрос выполнялся дважды) <br />
          - небольшая поправка вкладки "Нарушения" для использования по каналу
          ЕСПД. При создании нарушения список детей должен отображаться
          корректно.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 07.10.2026 (v0.299.2)</b>
        </div>
        <div class="list-versions-item-info">
          - для админа добавлена возможность добавлять информацию по движению
          автобусов в школе
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 21.09.2026 (v0.299.1)</b>
        </div>
        <div class="list-versions-item-info">
          - Для классных руководителей исправлен баг: классный руководитель мог
          выбрать кружки и секции школы в занятости. (Это делает только
          администратор, согласно заявкам в навигаторе)<br />
          - Обновлен интерфейс и вывод на печать для Зон риска - шапка таблицы
          печатается на каждом листе. При заполнении - можно убрать легенду и
          оставить только номер столбца. Окном легче управлять.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 16.09.2026 (v0.299)</b>
        </div>
        <div class="list-versions-item-info">
          - Для админа более удобный интерфейс по редактированию
          пользователей<br />
          - Для всех обновилась вкладка "Другие сервисы"
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 04.09.2026 (v0.298.4)</b>
        </div>
        <div class="list-versions-item-info">
          - Для админа появилась возможность редактировать учеников (ФИ и Пол) -
          В разделе "Ученики" теперь видно "Пол" ученика
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 03.09.2026 (v0.298.3)</b>
        </div>
        <div class="list-versions-item-info">
          - Попытка исправить проблему с Ростелеком ЕСПД для главной страницы
          (отображение учащихся в некоторых классах).
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 18.08.2026 (v0.298.2)</b>
        </div>
        <div class="list-versions-item-info">
          - добавлены настройки пользователей для модуля ACT.Задачи
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 10.08.2026 (v0.298.1)</b>
        </div>
        <div class="list-versions-item-info">
          - обновлена страница глобальные настройки для администратора.
          Возможность создавать копии базы данных
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 23.06.2026 (v0.298)</b>
        </div>
        <div class="list-versions-item-info">
          - Обновлен интерфейс страницы "Ученики" для администратора. Появились
          инструменты групповых операций для учеников.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 19.04.2026 (v0.297)</b>
        </div>
        <div class="list-versions-item-info">
          - Обновлен интерфейс страницы "Ученики". <br />- Добавлен модуль "Учет
          отдельных категорий несовершеннолетних (Мониторинг зон риска)"
          согласно документу «Положение об учете отдельных категорий
          несовершеннолетних в общеобразовательных и профессиональных
          образовательных организациях, подведомственных министерству
          образования и науки Краснодарского края»
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 05.04.2026 (v0.296)</b>
        </div>
        <div class="list-versions-item-info">
          - В чек-листе психоэмоционального состояния появилась возможность
          оставлять комментарий. Также даты последнего изменения и комментарий
          будут выводиться на печать. Полезно, если нужно зафиксировать, когда и
          кем была проведена беседа с ребенком или дать пояснение о проблемах.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 08.03.2026 (v0.295)</b>
        </div>
        <div class="list-versions-item-info">
          - Добавлена возможность привязки учеников к MAX-боту для выдачи
          пропусков в школу. Настройка для учеников на странице
          "Настройка->Ученики", кнопка НАСТРОЙКИ MAX. Также появилась
          возможность добавления ID MAX для сотрудника.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 25.12.2025 (v0.294)</b>
        </div>
        <div class="list-versions-item-info">
          - Добавлена система пропусков в школу. Настройка для учеников на
          странице "Настройка->Ученики", кнопка QR-коды
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 12.12.2025 (v0.293.3)</b>
        </div>
        <div class="list-versions-item-info">
          - Нарушения: для класса стало удобнее смотреть нарушения ученика. Для
          администратора: Появился свод по количеству нарушений в разрезе на
          классы.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 25.11.2025 (v0.293)</b>
        </div>
        <div class="list-versions-item-info">
          - Чек-лист психоэмоционального состояния: в Настройка->Ученики
          добавлен модуль Чек-лист психоэмоционального состояния. Это
          возможность отслеживать эмоциональное состояние детей, согласно
          рекомендациям.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 20.11.2025 (v0.290)</b>
        </div>
        <div class="list-versions-item-info">
          - АИК: в Нарушения добавлен модуль АИК - административынй
          индивидуальный контроль. На АИК можно направить учащихся, у которых
          имеется более 3-х нарушений. Дежурный администратор (или заместитель
          директора) будет проверять учащихся на АИК по различным критериям. По
          результатам 3-х проверок система будет выносить решение о снятии
          ученика с АИК или его продолжении.
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 06.11.2025 (v0.288)</b>
        </div>
        <div class="list-versions-item-info">
          - "Обновить ДО": теперь нельзя самостоятельно выбрать школьные кружки
          и секции в разделе "Настройка"->"Ученики" (данные по школьным кружкам
          и секциям может заполнять только администратор). Добавлена инструкция.
          В окне обновления ДО теперь виден класс и ФИ ребенка. Также можно
          отключать автоматическую перезагрузку страницы во время массового
          обновления ДО (для облегчения нагрузки на сервер).
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 21.10.2025 (v0.284)</b>
        </div>
        <div class="list-versions-item-info">
          - "Мероприятия": добавлена возможность редактировать мероприятия для
          администратора
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 17.10.2025 (v0.283)</b>
        </div>
        <div class="list-versions-item-info">
          - Добавлен модуль "Мероприятия" <br />
          Это календарь с мероприятиями, с возможностями фильтра по классам и
          параллелям. Любое мероприятие, созданное администратором будет видно
          всем в календаре. Это позволит спланировать работу, а также узнавать о
          предстоящих событиях школы
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 10.10.2025 (v0.282)</b>
        </div>
        <div class="list-versions-item-info">
          - Добавлена возможность переводить учеников в другой класс <br />
          - Добавлена возможность добавлять и удалять учеников из карточки
          нарушения <br />
          - Более стабильное первоначальное подключение к серверу
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 04.08.2025 18:16(v0.281)</b>
        </div>
        <div class="list-versions-item-info">
          - Добавлена возможность изменять учебный год. Настройки->Глобальные
          настройки
        </div>
      </div>
      <div class="list-versions-item">
        <div style="text-align: start">
          <b>Версия от 23.06.2025 13:40(v0.280)</b>
        </div>
        <div class="list-versions-item-info">
          - Добавлена проверка авторизации через токены <br />
          - Уменьшена нагрузка на заголовки при отправке запросов <br />
          - Добавлена страница "Информация о версиях" <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.main-infoVersions {
  color: white;
  height: 80vh;
  overflow-x: auto;
}
.list-versions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.list-versions-item {
  background-color: rgb(0, 0, 0);
  width: 60%;
  margin: 10px;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
}
.list-versions-item-info {
  color: black;
  background-color: rgb(233, 233, 233);

  padding: 5px;
  border-radius: 4px;
  text-align: start;
}
</style>
